<br />
<span>{{ "category_to_update" | translation }}: </span>
<br />
<p-select
  *ngIf="dataCategories"
  optionLabel="text"
  [options]="dataCategories"
  [(ngModel)]="selectedDataCategory"
  optionLabel="title"
  [placeholder]="'category' | translation"
  appendTo="body"
/>

<br />
<span>New Icon:</span>
<br />
<p-select
  optionLabel="text"
  *ngIf="iconCategories"
  [options]="iconCategories"
  [(ngModel)]="selectedCategory"
  optionLabel="title"
  [placeholder]="'category_icon' | translation"
  appendTo="body"
/>

<div style="margin: 10px 0px">
  <p-select
    *ngIf="!selectedCategory"
    [disabled]="!selectedCategory"
    [(ngModel)]="selectedIcon"
    [options]="iconOptions"
    [placeholder]="'icon' | translation"
    appendTo="body"
    [virtualScroll]="true"
    virtualScrollItemSize="20"
  >
  </p-select>

  <p-select
    *ngIf="selectedCategory"
    [(ngModel)]="selectedIcon"
    [options]="selectedCategory.items"
    optionLabel="title"
    [placeholder]="'icon' | translation"
    (onChange)="previewCat()"
    appendTo="body"
    [virtualScroll]="true"
    virtualScrollItemSize="20"
  >
    <ng-template #selectedItem let-selectedOption>
      <span
        *ngIf="selectedOption"
        [innerHTML]="getIconHtml(selectedIcon)"
      ></span>
    </ng-template>

    <ng-template let-icon #item>
      <i [ngClass]="icon"></i>
    </ng-template>
  </p-select>
</div>

<div *ngIf="selectedDataCategory && selectedIcon" class="row">
  <br />
  <span>{{ "menu_preview" | translation }}:</span>
  <br />
  <div class="col-md-3">
    <p-panelmenu
      [model]="previewList"
      status="primary"
    ></p-panelmenu>
  </div>
  <br />
  <div>
    <button pButton severity="primary" (click)="saveCategory()">
      {{ "save" | translation }}
    </button>
  </div>
</div>
